export default __webpack_public_path__ + "static/media/developmentNAPA.3c0e67c3.png";